import i18n, {InitOptions} from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './locales/en';
import appConfig from './appConfig';

const i18nConfig: InitOptions = {
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translation: en,
    },
  },
  interpolation: {
    escapeValue: false,
  },
  missingKeyHandler: (_lng, _ns, key) => {
    if (appConfig.appEnvironment !== 'production') {
      throw new Error(`Missing translation: ${key}`);
    }
  },
};

i18n.use(initReactI18next).init(i18nConfig);

export default i18n;
